import { featureFlags, localStorageCleanupVersionMapping } from 'v5/features';
import { createLocalStorageFeatureFlags } from 'v5/platform/feature-management/sources/localStorage';

export const myLocalStorageFeatureFlagSource = createLocalStorageFeatureFlags(
  'feature',
  featureFlags,
  localStorageCleanupVersionMapping
);
